import type { Participant } from "@/api/types";
import { Avatar } from "./Avatar";
import { participantLabel } from "@/utils/avatar";
import "./participant-chip.css";

export interface ParticipantChipProps {
  participant: Pick<Participant, "name" | "display_suffix">;
  /** Tagged consumer state (filled fg + underline). */
  tagged?: boolean;
  /** Quantity badge for US-14 unequal splits. Render "×N" suffix. */
  quantity?: number | null;
  /** Disabled = opted out of the receipt (dimmed + strike-through). */
  disabled?: boolean;
  onClick?: () => void;
  ariaPressed?: boolean;
}

export function ParticipantChip({
  participant,
  tagged = false,
  quantity,
  disabled = false,
  onClick,
  ariaPressed,
}: ParticipantChipProps) {
  const label = participantLabel(participant);
  const classes = [
    "wp-chip",
    tagged ? "wp-chip--tagged" : "wp-chip--untagged",
    disabled ? "wp-chip--disabled" : null,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-pressed={ariaPressed ?? tagged}
      aria-disabled={disabled || undefined}
      disabled={disabled && !onClick}
    >
      <Avatar participant={participant} size="sm" />
      <span className="wp-chip__name">{label}</span>
      {quantity && quantity > 1 ? (
        <span className="wp-chip__qty" aria-label={`порцій: ${quantity}`}>
          ×{quantity}
        </span>
      ) : null}
    </button>
  );
}
